import React, { useState } from 'react';

function Footer() {
    const [showModal, setShowModal] = useState(null);

    const currentYear = new Date().getFullYear();

    const closeModal = () => setShowModal(null);

    return (
        <>
            <footer className="app-footer">
                <div className="footer-content">
                    <div className="footer-left">
                        <span className="footer-copyright">
                            © {currentYear} DÉPARTEMENT MANAGER — Tous droits réservés
                        </span>
                        <span className="footer-version">{process.env.REACT_APP_VERSION || 'dev'}</span>
                    </div>
                    <div className="footer-links">
                        <button className="footer-link" onClick={() => setShowModal('mentions')}>
                            Mentions légales
                        </button>
                        <span className="footer-dot">•</span>
                        <button className="footer-link" onClick={() => setShowModal('confidentialite')}>
                            Politique de confidentialité
                        </button>
                        <span className="footer-dot">•</span>
                        <button className="footer-link" onClick={() => setShowModal('cgu')}>
                            CGU
                        </button>
                        <span className="footer-dot">•</span>
                        <button className="footer-link" onClick={() => setShowModal('cookies')}>
                            Cookies
                        </button>
                        <span className="footer-dot">•</span>
                        <button className="footer-link" onClick={() => setShowModal('accessibilite')}>
                            Accessibilité
                        </button>
                    </div>
                    <div className="footer-right">
                        <span className="footer-contact">
                            Contact : <a href="mailto:admin@iut.fr" className="footer-email">admin@iut.fr</a>
                        </span>
                    </div>
                </div>
            </footer>

            {/* ===== MODALES LÉGALES ===== */}
            {showModal && (
                <div className="modal" onClick={closeModal}>
                    <div className="legal-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="legal-modal-header">
                            <h2>{
                                showModal === 'mentions' ? '📜 Mentions légales' :
                                showModal === 'confidentialite' ? '🔒 Politique de confidentialité' :
                                showModal === 'cgu' ? '📋 Conditions Générales d\'Utilisation' :
                                showModal === 'cookies' ? '🍪 Politique de cookies' :
                                showModal === 'accessibilite' ? '♿ Déclaration d\'accessibilité' : ''
                            }</h2>
                            <button className="legal-modal-close" onClick={closeModal}>✕</button>
                        </div>
                        <div className="legal-modal-body">
                            {showModal === 'mentions' && <MentionsLegales />}
                            {showModal === 'confidentialite' && <PolitiqueConfidentialite />}
                            {showModal === 'cgu' && <CGU />}
                            {showModal === 'cookies' && <Cookies />}
                            {showModal === 'accessibilite' && <Accessibilite />}
                        </div>
                        <div className="legal-modal-footer">
                            <button className="btn btn-primary" onClick={closeModal}>Fermer</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

// ============================================
// MENTIONS LÉGALES
// ============================================
function MentionsLegales() {
    return (
        <div className="legal-content">
            <section>
                <h3>1. Éditeur du site</h3>
                <p>
                    <strong>Raison sociale :</strong> Institut Universitaire de Technologie (IUT)<br />
                    <strong>Forme juridique :</strong> Établissement public à caractère scientifique, culturel et professionnel (EPSCP)<br />
                    <strong>Adresse :</strong> [Adresse de l'IUT]<br />
                    <strong>Téléphone :</strong> [Numéro de téléphone]<br />
                    <strong>Email :</strong> <a href="mailto:admin@iut.fr">admin@iut.fr</a><br />
                    <strong>Directeur de la publication :</strong> [Nom du directeur]<br />
                    <strong>SIRET :</strong> [Numéro SIRET]
                </p>
            </section>

            <section>
                <h3>2. Hébergement</h3>
                <p>
                    <strong>Hébergeur :</strong> Hébergement interne — NAS Synology<br />
                    <strong>Localisation :</strong> France<br />
                    <strong>Infrastructure :</strong> Docker (PostgreSQL, Node.js, Nginx)<br />
                    Les données sont hébergées sur le territoire français conformément au RGPD.
                </p>
            </section>

            <section>
                <h3>3. Propriété intellectuelle</h3>
                <p>
                    L'ensemble du contenu de cette application (textes, graphismes, logiciels, images, bases de données)
                    est protégé par le droit d'auteur et le droit des bases de données. Toute reproduction, représentation,
                    modification ou exploitation non autorisée est interdite et constitue une contrefaçon sanctionnée par
                    les articles L.335-2 et suivants du Code de la propriété intellectuelle.
                </p>
            </section>

            <section>
                <h3>4. Responsabilité</h3>
                <p>
                    L'éditeur s'efforce de fournir des informations exactes et à jour. Toutefois, il ne peut garantir
                    l'exactitude, la complétude ou l'actualité des informations diffusées. L'utilisateur reconnaît
                    utiliser ces informations sous sa responsabilité exclusive.
                </p>
            </section>

            <section>
                <h3>5. Droit applicable</h3>
                <p>
                    Le présent site et ses mentions légales sont régis par le droit français. En cas de litige,
                    les tribunaux français seront seuls compétents.
                </p>
            </section>
        </div>
    );
}

// ============================================
// POLITIQUE DE CONFIDENTIALITÉ (RGPD)
// ============================================
function PolitiqueConfidentialite() {
    return (
        <div className="legal-content">
            <section>
                <h3>1. Responsable du traitement</h3>
                <p>
                    Le responsable du traitement des données personnelles est l'IUT, représenté par son directeur.
                    Pour toute question relative à la protection de vos données, vous pouvez contacter le Délégué
                    à la Protection des Données (DPO) à l'adresse : <a href="mailto:dpo@iut.fr">dpo@iut.fr</a>
                </p>
            </section>

            <section>
                <h3>2. Données collectées</h3>
                <p>Dans le cadre de l'utilisation de l'application, nous collectons les données suivantes :</p>
                <table className="legal-table">
                    <thead>
                        <tr>
                            <th>Donnée</th>
                            <th>Finalité</th>
                            <th>Base légale</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Nom, prénom</td>
                            <td>Identification de l'utilisateur</td>
                            <td>Intérêt légitime</td>
                        </tr>
                        <tr>
                            <td>Adresse email</td>
                            <td>Authentification, communication</td>
                            <td>Exécution du contrat</td>
                        </tr>
                        <tr>
                            <td>Mot de passe (hashé)</td>
                            <td>Sécurité de l'accès</td>
                            <td>Exécution du contrat</td>
                        </tr>
                        <tr>
                            <td>Rôle / Département</td>
                            <td>Gestion des droits d'accès</td>
                            <td>Intérêt légitime</td>
                        </tr>
                        <tr>
                            <td>Logs de connexion</td>
                            <td>Sécurité, traçabilité</td>
                            <td>Obligation légale</td>
                        </tr>
                        <tr>
                            <td>Données de planning</td>
                            <td>Fonctionnement du service</td>
                            <td>Exécution du contrat</td>
                        </tr>
                    </tbody>
                </table>
            </section>

            <section>
                <h3>3. Durée de conservation</h3>
                <ul>
                    <li><strong>Comptes utilisateurs :</strong> Durée d'activité du compte + 1 an après désactivation</li>
                    <li><strong>Logs de connexion :</strong> 12 mois (conformément à la loi)</li>
                    <li><strong>Données de planning :</strong> Durée de l'année scolaire + 3 ans d'archivage</li>
                    <li><strong>Mots de passe :</strong> Supprimés à la suppression du compte</li>
                </ul>
            </section>

            <section>
                <h3>4. Destinataires des données</h3>
                <p>
                    Les données sont accessibles uniquement aux personnes habilitées au sein de l'IUT :
                    administrateurs, gestionnaires de département. Aucune donnée n'est transmise à des tiers,
                    sauf obligation légale.
                </p>
            </section>

            <section>
                <h3>5. Transfert de données</h3>
                <p>
                    Aucun transfert de données personnelles n'est effectué en dehors de l'Union Européenne.
                    Les données sont hébergées en France sur un serveur interne (NAS Synology).
                </p>
            </section>

            <section>
                <h3>6. Sécurité</h3>
                <p>Nous mettons en œuvre les mesures techniques et organisationnelles suivantes :</p>
                <ul>
                    <li>Chiffrement des mots de passe (bcrypt)</li>
                    <li>Authentification par token JWT avec expiration</li>
                    <li>Connexion HTTPS obligatoire</li>
                    <li>Accès restreint par rôles (admin, gestionnaire, lecture seule)</li>
                    <li>Base de données non exposée publiquement</li>
                    <li>Sauvegardes régulières</li>
                </ul>
            </section>

            <section>
                <h3>7. Vos droits (RGPD — Articles 15 à 22)</h3>
                <p>Conformément au Règlement Général sur la Protection des Données, vous disposez des droits suivants :</p>
                <ul>
                    <li><strong>Droit d'accès</strong> — Obtenir une copie de vos données personnelles</li>
                    <li><strong>Droit de rectification</strong> — Corriger des données inexactes</li>
                    <li><strong>Droit à l'effacement</strong> — Demander la suppression de vos données</li>
                    <li><strong>Droit à la limitation</strong> — Restreindre le traitement de vos données</li>
                    <li><strong>Droit à la portabilité</strong> — Recevoir vos données dans un format structuré</li>
                    <li><strong>Droit d'opposition</strong> — Vous opposer au traitement de vos données</li>
                </ul>
                <p>
                    Pour exercer ces droits, contactez-nous à <a href="mailto:dpo@iut.fr">dpo@iut.fr</a>.
                    Nous répondrons dans un délai de 30 jours.
                </p>
                <p>
                    En cas de litige, vous pouvez introduire une réclamation auprès de la CNIL :
                    <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer"> www.cnil.fr</a>
                </p>
            </section>
        </div>
    );
}

// ============================================
// CGU
// ============================================
function CGU() {
    return (
        <div className="legal-content">
            <section>
                <h3>1. Objet</h3>
                <p>
                    Les présentes Conditions Générales d'Utilisation (CGU) régissent l'accès et l'utilisation
                    de l'application « Planning IUT », un outil de gestion des plannings d'alternance
                    des formations BUT au sein de l'IUT.
                </p>
            </section>

            <section>
                <h3>2. Accès au service</h3>
                <p>
                    L'accès à l'application est réservé aux utilisateurs disposant d'un compte créé par
                    un administrateur. L'utilisation requiert une authentification par email et mot de passe.
                </p>
                <p>
                    L'utilisateur s'engage à :
                </p>
                <ul>
                    <li>Ne pas communiquer ses identifiants de connexion à des tiers</li>
                    <li>Utiliser un mot de passe robuste</li>
                    <li>Signaler immédiatement toute utilisation non autorisée de son compte</li>
                    <li>Se déconnecter après chaque session sur un poste partagé</li>
                </ul>
            </section>

            <section>
                <h3>3. Rôles et permissions</h3>
                <table className="legal-table">
                    <thead>
                        <tr>
                            <th>Rôle</th>
                            <th>Permissions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><strong>Administrateur</strong></td>
                            <td>Gestion complète : utilisateurs, départements, configuration, planning</td>
                        </tr>
                        <tr>
                            <td><strong>Gestionnaire</strong></td>
                            <td>Gestion du planning des départements attribués</td>
                        </tr>
                        <tr>
                            <td><strong>Lecture seule</strong></td>
                            <td>Consultation du planning uniquement</td>
                        </tr>
                    </tbody>
                </table>
            </section>

            <section>
                <h3>4. Utilisation du service</h3>
                <p>L'utilisateur s'engage à utiliser l'application de manière loyale et à ne pas :</p>
                <ul>
                    <li>Tenter d'accéder à des données non autorisées</li>
                    <li>Perturber le fonctionnement de l'application</li>
                    <li>Extraire massivement des données (scraping)</li>
                    <li>Utiliser l'application à des fins autres que la gestion des plannings</li>
                    <li>Introduire des contenus malveillants</li>
                </ul>
            </section>

            <section>
                <h3>5. Disponibilité</h3>
                <p>
                    L'éditeur s'efforce de maintenir l'application accessible 24h/24, 7j/7.
                    Toutefois, l'accès peut être interrompu pour des opérations de maintenance,
                    mises à jour ou en cas de force majeure. Aucune indemnité ne pourra être réclamée
                    en cas d'interruption du service.
                </p>
            </section>

            <section>
                <h3>6. Propriété des données</h3>
                <p>
                    Les données de planning saisies dans l'application restent la propriété de l'IUT.
                    Les utilisateurs qui saisissent ces données le font dans le cadre de leurs fonctions
                    au sein de l'établissement.
                </p>
            </section>

            <section>
                <h3>7. Responsabilité</h3>
                <p>
                    L'éditeur ne saurait être tenu responsable des dommages directs ou indirects résultant
                    de l'utilisation ou de l'impossibilité d'utiliser l'application, y compris la perte de données.
                    L'utilisateur est responsable de la véracité des informations qu'il saisit.
                </p>
            </section>

            <section>
                <h3>8. Modification des CGU</h3>
                <p>
                    L'éditeur se réserve le droit de modifier les présentes CGU à tout moment.
                    Les utilisateurs seront informés de toute modification substantielle.
                    La poursuite de l'utilisation de l'application après modification vaut acceptation
                    des nouvelles CGU.
                </p>
            </section>

            <section>
                <h3>9. Droit applicable</h3>
                <p>
                    Les présentes CGU sont régies par le droit français. Tout litige sera soumis
                    aux tribunaux compétents du ressort du siège de l'IUT.
                </p>
            </section>
        </div>
    );
}

// ============================================
// COOKIES
// ============================================
function Cookies() {
    return (
        <div className="legal-content">
            <section>
                <h3>1. Qu'est-ce qu'un cookie ?</h3>
                <p>
                    Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, tablette, smartphone)
                    lors de la visite d'un site web. Il permet de stocker des informations relatives à votre navigation.
                </p>
            </section>

            <section>
                <h3>2. Cookies utilisés</h3>
                <table className="legal-table">
                    <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Type</th>
                            <th>Finalité</th>
                            <th>Durée</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><code>token</code></td>
                            <td>Strictement nécessaire</td>
                            <td>Authentification JWT — maintien de la session</td>
                            <td>24 heures</td>
                        </tr>
                        <tr>
                            <td><code>localStorage</code></td>
                            <td>Strictement nécessaire</td>
                            <td>Stockage du token d'authentification et préférences d'affichage</td>
                            <td>Session</td>
                        </tr>
                    </tbody>
                </table>
            </section>

            <section>
                <h3>3. Cookies tiers</h3>
                <p>
                    Cette application <strong>n'utilise aucun cookie tiers</strong> :
                </p>
                <ul>
                    <li>❌ Aucun cookie publicitaire</li>
                    <li>❌ Aucun cookie de tracking / analytics</li>
                    <li>❌ Aucun cookie de réseau social</li>
                    <li>❌ Aucun cookie de profilage</li>
                </ul>
            </section>

            <section>
                <h3>4. Base légale</h3>
                <p>
                    Les cookies utilisés sont exclusivement des <strong>cookies strictement nécessaires</strong>
                    au fonctionnement du service (authentification). Conformément à l'article 82 de la loi
                    Informatique et Libertés et à la directive ePrivacy, ces cookies sont exemptés du
                    recueil de consentement car indispensables à la fourniture du service.
                </p>
            </section>

            <section>
                <h3>5. Gestion des cookies</h3>
                <p>
                    Vous pouvez configurer votre navigateur pour bloquer les cookies. Toutefois, le blocage
                    des cookies strictement nécessaires empêchera l'utilisation de l'application
                    (impossibilité de se connecter).
                </p>
                <p>Paramétrage selon votre navigateur :</p>
                <ul>
                    <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
                    <li><a href="https://support.mozilla.org/fr/kb/activer-desactiver-cookies" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
                    <li><a href="https://support.microsoft.com/fr-fr/microsoft-edge" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
                    <li><a href="https://support.apple.com/fr-fr/guide/safari" target="_blank" rel="noopener noreferrer">Safari</a></li>
                </ul>
            </section>
        </div>
    );
}

// ============================================
// ACCESSIBILITÉ
// ============================================
function Accessibilite() {
    return (
        <div className="legal-content">
            <section>
                <h3>1. Engagement</h3>
                <p>
                    L'IUT s'engage à rendre cette application accessible conformément à l'article 47 de la loi
                    n°2005-102 du 11 février 2005 et au Référentiel Général d'Amélioration de l'Accessibilité (RGAA).
                </p>
            </section>

            <section>
                <h3>2. État de conformité</h3>
                <p>
                    Cette application est en <strong>conformité partielle</strong> avec le RGAA 4.1.
                    Un audit complet n'a pas encore été réalisé.
                </p>
            </section>

            <section>
                <h3>3. Contenus non accessibles</h3>
                <p>Les contenus suivants peuvent présenter des difficultés d'accessibilité :</p>
                <ul>
                    <li>La grille calendrier peut être complexe à naviguer au clavier</li>
                    <li>Certains contrastes de couleurs dans les cellules F/E/S</li>
                    <li>Le drag & drop pour la saisie des périodes</li>
                    <li>Les popups d'événements</li>
                </ul>
            </section>

            <section>
                <h3>4. Améliorations prévues</h3>
                <ul>
                    <li>Navigation clavier complète dans le calendrier</li>
                    <li>Ajout d'attributs ARIA sur les éléments interactifs</li>
                    <li>Amélioration des contrastes</li>
                    <li>Alternative au drag & drop</li>
                    <li>Tests avec lecteurs d'écran</li>
                </ul>
            </section>

            <section>
                <h3>5. Retour d'information</h3>
                <p>
                    Si vous rencontrez un défaut d'accessibilité vous empêchant d'accéder à un contenu
                    ou une fonctionnalité, contactez-nous à <a href="mailto:admin@iut.fr">admin@iut.fr</a>.
                    Nous nous engageons à vous répondre dans un délai de 15 jours.
                </p>
            </section>

            <section>
                <h3>6. Voies de recours</h3>
                <p>Si vous n'obtenez pas de réponse satisfaisante, vous pouvez :</p>
                <ul>
                    <li>Contacter le Défenseur des droits : <a href="https://www.defenseurdesdroits.fr" target="_blank" rel="noopener noreferrer">www.defenseurdesdroits.fr</a></li>
                    <li>Écrire au Défenseur des droits — Libre réponse 71120 — 75342 Paris CEDEX 07</li>
                </ul>
            </section>
        </div>
    );
}

export default Footer;